import { UserAdministrationActions } from './useradministration.actions';

const convertArrayIntoObject = (array) => {
  const mapped = array.map((item) => ({ [item.name]: item.description }));
  return Object.assign({}, ...mapped);
};

export const UserAdministration = {
  namespaced: true,
  state: () => ({
    userList: [],
    editedItem: {},
    editedIndex: undefined,
    dialog: undefined,
    rolesList: [],
    rolesConst: {},
    machineTokens: [],
    machineTokenScopes: [],
    machineTokenEnrollments: [],
  }),
  mutations: {
    setUsersList(state, results) {
      state.userList = results;
    },
    setEditedItem(state, item) {
      state.editedItem = item;
    },
    setEditedIndex(state, index) {
      state.editedIndex = index;
    },
    setDialog(state, dialog) {
      state.dialog = dialog;
    },
    setRolesList(state, roles) {
      state.rolesList = roles;
    },
    setRolesConst(state, roles) {
      state.rolesConst = convertArrayIntoObject(roles);
    },
    setMachineTokens(state, tokens) {
      state.machineTokens = tokens || [];
    },
    setMachineTokenScopes(state, scopes) {
      state.machineTokenScopes = scopes || [];
    },
    setMachineTokenEnrollments(state, enrollments) {
      state.machineTokenEnrollments = enrollments || [];
    },
  },
  actions: {
    ...UserAdministrationActions,
  },
};

export default UserAdministration;
